import { createFileRoute } from '@tanstack/react-router';
import { redirectFromEntry } from '@/app/entry/portalGuards';

// `/` lleva al portal según los permisos: 0 → /no-access, 1 → directo, varios → selector.
export const Route = createFileRoute('/_authenticated/_layout/')({
    beforeLoad: ({ context }) => redirectFromEntry(context.auth),
});
